import { useEffect, useMemo, useState } from "react";
import { Scheduling } from "../models/schedule";
import { fetchConsultantSchedulings, fetchFleetSchedulings } from "../api/fetchScheduling";
import { debounce } from "lodash";

function useSchedulingList(userType: string) {
    const [lastKey, setLastKey] = useState<string | null>();
    const [sortDirection, setSortDirection] = useState<string>("asc");
    const [queryChassis, setQueryChassis] = useState<string>("");
    const [date, setDate] = useState<moment.Moment | null>(null);
    const [datePickerKey, setDatePickerKey] = useState<number>(0);
    
    const [loading, setLoading] = useState<boolean>(false);
    const [hasMoreData, setHasMoreData] = useState<boolean>(true);

    const [schedulings, setSchedulings] = useState<Scheduling[]>([]);

    useEffect(() => {
        setLastKey(null);
        setSchedulings([]);
        getSchedulings(null, []);
    }, [sortDirection, queryChassis, date]);

    const searchByChassis = useMemo(() => debounce(async (searchTerm: string) => setQueryChassis(searchTerm), 500), []);

    const getSchedulings = async (localLastKey?: string | null, localSchedulings?: Scheduling[]) => {
        setLoading(true);
        const data = userType === 'dealership' ?
            await fetchConsultantSchedulings(localLastKey ?? lastKey, sortDirection, queryChassis, date?.format("YYYY-MM-DD")) :
            await fetchFleetSchedulings(localLastKey ?? lastKey, sortDirection, queryChassis, date?.format("YYYY-MM-DD"));

        setSchedulings([...(localSchedulings ?? schedulings), ...data.items]);
        setLastKey(data.lastKey);
        setHasMoreData(!(data.items.length < 20));
        setLoading(false);
    }

    const clearDateFilter = () => {
        setDate(null);
        setDatePickerKey((prevKey) => prevKey + 1);
    }

    return { 
        schedulings, getSchedulings,
        sortDirection, setSortDirection, 
        searchByChassis, 
        date, setDate, datePickerKey, clearDateFilter, 
        loading, hasMoreData 
    }
}

export default useSchedulingList;